/* ════ LEVEL-UP SOUND ══════════════════════════════════════ */
// A little 1980s-arcade "level up!" jingle, synthesised with Web Audio square
// waves (no sound file). Browsers only allow sound after the person has
// interacted with the page, so the audio context is unlocked on their first
// click or key press; until then it stays silent.
let ctx = null;

function unlock() {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === 'suspended') ctx.resume();
  } catch (e) { /* no audio available */ }
}
['pointerdown', 'keydown'].forEach(ev => window.addEventListener(ev, unlock, { passive: true }));

// One chiptune note: square wave, instant attack, short decay.
function blip(out, freq, at, len, vibrato = false) {
  const o = ctx.createOscillator(), g = ctx.createGain();
  o.type = 'square'; o.frequency.setValueAtTime(freq, at);
  g.gain.setValueAtTime(0.0001, at);
  g.gain.linearRampToValueAtTime(1, at + 0.005);
  g.gain.setValueAtTime(1, at + len * 0.7);
  g.gain.exponentialRampToValueAtTime(0.0001, at + len);
  if (vibrato) {   // the classic wobble on the final note
    const lfo = ctx.createOscillator(), depth = ctx.createGain();
    lfo.frequency.value = 12; depth.gain.value = freq * 0.02;
    lfo.connect(depth); depth.connect(o.frequency);
    lfo.start(at); lfo.stop(at + len);
  }
  o.connect(g); g.connect(out);
  o.start(at); o.stop(at + len + 0.02);
}

export function levelUp() {
  try {
    unlock();
    if (!ctx || ctx.state !== 'running') return;
    const out = ctx.createGain(); out.gain.value = 0.07;   // square waves are loud; keep it polite
    out.connect(ctx.destination);
    const t = ctx.currentTime + 0.03, step = 0.065;
    // G4 C5 E5 G5 C6 E6 G6 ... then a held C7
    [392, 523.25, 659.25, 783.99, 1046.5, 1318.5, 1568].forEach((f, i) => blip(out, f, t + i * step, step * 0.95));
    blip(out, 2093, t + 7 * step, 0.42, true);
  } catch (e) { /* ignore */ }
}
